export const UNSAVED_CHANGES_MESSAGE =
  "You have unsaved changes. Leave without saving?";

export type UnsavedFormValue = string | number | boolean | null | undefined;

export type UnsavedFormSnapshot = Record<string, UnsavedFormValue>;

export function normalizeUnsavedValue(value: UnsavedFormValue): string {
  if (typeof value === "boolean") {
    return value ? "true" : "false";
  }
  return String(value ?? "").trim();
}

export function hasUnsavedChanges(
  current: UnsavedFormSnapshot,
  saved: UnsavedFormSnapshot,
): boolean {
  const keys = new Set([...Object.keys(current), ...Object.keys(saved)]);
  for (const key of keys) {
    if (normalizeUnsavedValue(current[key]) !== normalizeUnsavedValue(saved[key])) {
      return true;
    }
  }
  return false;
}

export function confirmDiscardUnsavedChanges(
  enabled: boolean,
  message: string,
  confirmLeave: (message: string) => boolean,
): boolean {
  if (!enabled) {
    return true;
  }
  return confirmLeave(message);
}
